import { makeStyles } from '@material-ui/core/styles';
import ContainerBackgroundImage from '@assets/new-overview-initial-bg-2.svg';
const useStyles = makeStyles(({ breakpoints,variables, palette }) => ({
  courierInitialContentContainer: {
    background:`url(${ContainerBackgroundImage}) no-repeat`,
    backgroundColor: palette?.jet?.containerDark,
    backgroundPosition: '-766px -389px',
    backgroundSize: '1949px 1170px',
    height: '620px',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '195px',
    position:'relative',
    [breakpoints.down('xs')]:{ 
      paddingTop:variables?.spacingG,
      height: '432px',
      backgroundImage:'none'
  }
  },
  courierInitialContent: {
    color: palette?.jet?.containerDefault,
    zIndex:1,
    width: '900px',
    paddingLeft:variables?.spacingD,
    paddingRight:variables?.spacingD,
    [breakpoints.down('xs')]:{ 
      width: '100%',
      paddingLeft:variables?.spacingF,
      paddingRight:variables?.spacingF
    },
    '& .jetButton': {
      width:'auto !important',
      paddingLeft:variables?.spacingC,
      paddingRight:variables?.spacingC,
      minWidth:'257px !important',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: variables?.spacingE,
      [breakpoints.down('xs')]:{ 
        marginBottom:variables?.spacingG,
        minWidth:'186px !important',
        display:'unset',
      }
    },
    '& .courier-initial-content-title':{
      [breakpoints.down('xs')]:{ 
        marginBottom:variables?.spacingC
      }
    },
    '& .badge_holder': {
      marginLeft: 'auto',
      marginRight: 'auto',
      width: '265px',
      display: 'flex',
      justifyContent: 'space-around',
      marginTop: variables?.spacingG,
      '& img':{
        cursor:'pointer'
      }
    },
    '& .smartphoneimage': {
      pointerEvents:'none',
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '60px',
      [breakpoints.down('xs')]:{ 
        width:'275px',
        height:'100px',
        left: 'calc(50% - 137px)',
        position:'absolute',
        bottom:'-45px'
       }
    },
  },
}));

export default useStyles;
